import { useDebounce } from '~/hooks'
import { useWstEth2StEthRate } from './useWstEth2StEthRate'

export const useUnwrapReceiveAmount = (amount: string | null) => {
  const fallbackAmount = amount || '0'
  const debouncedAmount = useDebounce(fallbackAmount, 500)
  const { rate } = useWstEth2StEthRate(debouncedAmount)
  return rate
}
